// FG: drag Hyper's spotlight-picks "Offers" teaser up or down the right edge.
// A tap still opens the drawer; the tab stays below the sticky header and above
// the sticky add-to-cart bar; the position is remembered per browser.
(() => {
  const tab = document.querySelector('.toggle-spotlight-drawer');
  if (!tab) return;

  const KEY = 'fg:offersTabOffset';
  const THRESHOLD = 6;
  const GAP = 12;
  let offset = 0;
  let startY = 0;
  let startOffset = 0;
  let pointerId = null;
  let dragged = false;

  const isShown = () => tab.getClientRects().length > 0;

  const clamp = (value) => {
    const rect = tab.getBoundingClientRect();
    const header = document.querySelector('header[is="sticky-header"]');
    const bar = document.querySelector('.sticky-atc-bar');
    const minTop = Math.max(header ? header.getBoundingClientRect().bottom : 0, 0) + GAP;
    const reserve = bar ? bar.offsetHeight + (parseFloat(getComputedStyle(bar).bottom) || 0) : 0;
    const maxBottom = window.innerHeight - reserve - GAP;
    const min = minTop - (rect.top - offset);
    const max = maxBottom - (rect.bottom - offset);
    return Math.min(Math.max(value, min), max);
  };

  const apply = (value) => {
    offset = value;
    tab.style.translate = `0 ${value}px`;
  };

  const saved = parseFloat(localStorage.getItem(KEY));
  if (saved) apply(isShown() ? clamp(saved) : saved);

  tab.style.touchAction = 'none';

  tab.addEventListener('pointerdown', (event) => {
    if (event.button !== 0) return;
    pointerId = event.pointerId;
    startY = event.clientY;
    startOffset = offset;
    dragged = false;
  });

  tab.addEventListener('pointermove', (event) => {
    if (event.pointerId !== pointerId) return;
    const dy = event.clientY - startY;
    if (!dragged && Math.abs(dy) < THRESHOLD) return;
    if (!dragged) {
      dragged = true;
      tab.setPointerCapture(pointerId);
    }
    event.preventDefault();
    apply(clamp(startOffset + dy));
  });

  const end = (event) => {
    if (event.pointerId !== pointerId) return;
    pointerId = null;
    if (dragged) localStorage.setItem(KEY, offset);
  };
  tab.addEventListener('pointerup', end);
  tab.addEventListener('pointercancel', end);

  // A drag must not also open the drawer or hit the close button.
  document.addEventListener(
    'click',
    (event) => {
      if (!dragged || !tab.contains(event.target)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      dragged = false;
    },
    true
  );

  window.addEventListener('resize', () => {
    if (offset && isShown()) apply(clamp(offset));
  });
})();
